import { useContext, useEffect } from 'react'
import { getSecurityForHolder } from 'services/research'
import { Context as AffiliationHoldingContext } from '../contexts/AffiliationHoldingContext'

import useSearchInputRead from '../hooks/useSearchInputRead'

function useAffiliationHoldings() {
  const context = useContext(AffiliationHoldingContext)

  const { affiliatedId } = useSearchInputRead()

  const [state, dispatch] = context

  useEffect(() => {
    const fetchAffiliationHoldings = async ({ affiliatedId }) => {
      try {
        const options = {
          holderId: affiliatedId,
          page_offset: state.page * state.rowsPerPage, // Need to start at 0 to support @material-ui pagination
          page_size: Number(state.rowsPerPage),
        }
        dispatch({ type: 'AFFILIATION_HOLDING:FETCH_STARTED' })
        const {
          data,
          total,
          links: { self, next, prev },
        } = await getSecurityForHolder(options)
        dispatch({
          type: 'AFFILIATION_HOLDING:FETCH_RECEIVED',
          payload: {
            affiliations: data,
            total: total,
            self: self,
            next: next,
            prev: prev,
            page: state.page,
            rowsPerPage: state.rowsPerPage,
          },
        })
      } catch (error) {
        dispatch({ type: 'AFFILIATION_HOLDING:FAILED', payload: error })
      }
    }

    if (affiliatedId) {
      fetchAffiliationHoldings({ affiliatedId })
    }
  }, [dispatch, affiliatedId, state.page, state.rowsPerPage])

  const setPage = page => {
    dispatch({ type: 'AFFILIATION_HOLDING:SET_PAGE', payload: { page } })
  }

  const setRowsPerPage = ({ page, rowsPerPage }) => {
    dispatch({ type: 'AFFILIATION_HOLDING:SET_ROWS_PER_PAGE', payload: { page, rowsPerPage } })
  }

  const handlePage = newPage => {
    const page = state.page
    if (newPage > page && newPage < state.total) {
      setPage(page + 1)
    } else if (newPage < page) {
      setPage(page - 1)
    }
  }

  return {
    state,
    setPage: handlePage,
    setRowsPerPage,
  }
}

export default useAffiliationHoldings
